import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-sopo-badge',
    templateUrl: './sopo-badge.component.html',
    styleUrls: ['./sopo-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SopoBadgeComponent implements OnInit {
    @Input() displayCount = true;
    @Input() count: string | number = 0;

    constructor() {}

    ngOnInit() {}
}
